import React from 'react'
import { Box, Button } from '@mui/material'
import { IFiltrosMetricas } from '..'
import DesplegableRubros from '../../AdminProducts/ABMProducts/components/DesplegableRubros'

const FiltrosMetricas: React.FC<{
  id: string
  enabled: boolean
  rubros: any[]
  filtros: IFiltrosMetricas
  setFiltros: (f: IFiltrosMetricas) => void
}> = ({ id, enabled, rubros, filtros, setFiltros }) => {
  const rubro: any = rubros?.find((r: any) => r.codRubro === filtros.codRubro || r.codigo === filtros.codRubro) || null
  const periodos = [
    { label: 'Últimos 30 Días', value: '30d' },
    { label: 'Últimos 7 días', value: '7d' },
    { label: 'Ayer', value: '1d' }
  ]
  const miLocal = [
    { label: 'Mi tienda', value: true, show: true },
    { label: 'Todos los vendedores', value: false, show: enabled }
  ]
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
        flexWrap: 'wrap'
      }}
    >
      {id.includes('Prod') && (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '0.5rem', flexWrap: 'wrap' }}>
          {miLocal.map((local) => (
            <Button
              key={local.label}
              variant={filtros.miLocal ? 'contained' : 'outlined'}
              onClick={() => setFiltros({ ...filtros, miLocal: local.value })}
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                fontSize: '13px',
                fontWeight: 500,
                padding: '6px 16px',
                minWidth: 'auto',
                whiteSpace: 'nowrap',
                ...(filtros.miLocal === local.value
                  ? {
                      backgroundColor: '#1976d2',
                      color: '#ffffff',
                      border: 'none',
                      '&:hover': {
                        backgroundColor: '#1565c0'
                      }
                    }
                  : {
                      backgroundColor: 'transparent',
                      color: '#666',
                      borderColor: '#d0d0d0',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                        borderColor: '#b0b0b0'
                      }
                    })
              }}
            >
              {local.label}
            </Button>
          ))}
        </Box>
      )}
      {enabled && (
        <>
          <DesplegableRubros
            rubros={rubros}
            onChange={(r: any) => {
              setFiltros({ ...filtros, codRubro: r?.codRubro || r?.codigo || null })
            }}
            value={rubro}
            sx={{
              '& .MuiInputBase-root': {
                height: '36px',
                minHeight: '36px',
                fontSize: '13px'
              },
              '& .MuiSelect-select': {
                padding: '6px 16px',
                display: 'flex',
                alignItems: 'center',
                fontSize: '13px'
              },
              '& .MuiMenuItem-root': {
                fontSize: '13px'
              }
            }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: '0.5rem', flexWrap: 'wrap' }}>
            {periodos.map((periodo) => (
              <Button
                key={periodo.value}
                variant={filtros.periodo === periodo.value ? 'contained' : 'outlined'}
                onClick={() => setFiltros({ ...filtros, periodo: periodo.value })}
                sx={{
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontSize: '13px',
                  fontWeight: 500,
                  padding: '6px 16px',
                  minWidth: 'auto',
                  whiteSpace: 'nowrap',
                  ...(filtros.periodo === periodo.value
                    ? {
                        backgroundColor: '#1976d2',
                        color: '#ffffff',
                        border: 'none',
                        '&:hover': {
                          backgroundColor: '#1565c0'
                        }
                      }
                    : {
                        backgroundColor: 'transparent',
                        color: '#666',
                        borderColor: '#d0d0d0',
                        '&:hover': {
                          backgroundColor: '#f5f5f5',
                          borderColor: '#b0b0b0'
                        }
                      })
                }}
              >
                {periodo.label}
              </Button>
            ))}
          </Box>
        </>
      )}
    </Box>
  )
}

export default FiltrosMetricas
